import { countries } from 'countries-list';
import { CountryCode } from 'libphonenumber-js';

import { PhoneInputOption } from './phone-input.models';

export const PHONE_INPUT_OPTIONS: PhoneInputOption[] = Object.entries(countries).map(([code, data]) => ({
  code: code as CountryCode, // The countries-list package types codes as string, but they are actually CountryCode
  name: data.name,
  countryCallingCode: data.phone[0].toString(),
}));
